<oui-layout
  [logoUrl]="logoSrc"
  [menuType]="'internal'">
  <oui-content-layout>
    <!-- template to display the document viewer in a slide panel. for now it is directly define here but if there is several document viewer it could be in a switch component -->
    <ng-template #documentViewerPortalContent>
      <app-recueil-document-viewer></app-recueil-document-viewer>
    </ng-template>
    <ng-template #qpiViewerPortalContent>
      <app-qpi-viewer-page></app-qpi-viewer-page>
    </ng-template>
    <ng-template #derViewerPortalContent>
      <app-der-viewer-page></app-der-viewer-page>
    </ng-template>
    <ng-template #filtrerPortalContent>
      <app-filtrer-investisseurs></app-filtrer-investisseurs>
    </ng-template>
    <ng-template #signatairePortalContent>
      <app-signataire-details></app-signataire-details>
    </ng-template>
    <ng-template #filePortalContent>
      <app-file-viewer></app-file-viewer>
    </ng-template>
    <ng-template #reglementPortalContent>
      <oui-document-viewer
        class="slide-reglement"
        [documentUrl]="reglementFile()"
        [showControls]="false">
      </oui-document-viewer>
    </ng-template>
    <ng-template #documentRequestPortalContent>
      @if (documentRequestPanelService.derStepRequired()) {
        <app-der-step
          mode="documentRequest"
          [investisseurContext]="!documentRequestPanelService.bulkRecipients()"
          (validated)="documentRequestPanelService.validateDer($event)"
          (closed)="documentRequestPanelService.closePanel()">
        </app-der-step>
      } @else {
        <app-document-request-creation></app-document-request-creation>
      }
    </ng-template>

    <div class="app-container">
      @if (layoutService.menuDisplayed()) {
        <oui-side-nav-menu
          [menuItems]="computedMenuItems()"
          [helpHref]="helpHref"
          [logoSrc]="navLogoSrc"
          [userName]="authService.getUserInfo().fullName"
          [avatarSrc]="authService.consultantProfilePicture()"
          [avatarMenuItems]="avatarMenuItems"
          [avatarSecondaryMenuItems]="secondaryMenuItems"
          [appVersion]="currentVersion">
        </oui-side-nav-menu>
      }
      <div class="main-container">
        <div class="content-container">
          <router-outlet> </router-outlet>
        </div>
      </div>
    </div>

    @if (loadingService.isLoading$ | async) {
      <div class="loader">
        <oui-loading class="center"></oui-loading>
      </div>
    }
  </oui-content-layout>
</oui-layout>
